"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentSize = exports.useContentSize = exports.context = exports.DEFAULT = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.DEFAULT = {
    width: typeof window === 'object' ? window.innerWidth : 0,
    height: typeof window === 'object' ? window.innerHeight : 0,
    paddingLeft: 0,
};
exports.context = React.createContext(exports.DEFAULT);
const useContentSize = () => React.useContext(exports.context);
exports.useContentSize = useContentSize;
const ContentSize = ({ render }) => render((0, exports.useContentSize)());
exports.ContentSize = ContentSize;
